<template>
  <!-- Figma D1/D4 "Add Misc. Items": title + "Add Items Manually", #A3AAD2 header row, rows with title / $ price / Recommended–Required / delete -->
  <main class="additionComponentPg font-roboto">
    <div class="flex flex-wrap items-center justify-between gap-2 pb-[15px]">
      <div class="flex items-center gap-1">
        <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
        <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
        <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">Add Misc. Items</p>
      </div>
      <!-- below laptop (Figma mobile): own row on the right, filled -->
      <button type="button" class="mobile:ml-auto laptop:ml-0 flex items-center gap-[10px] h-[36px] pl-[5px] pr-[15px] rounded-full border-1 text-[14px] mobile:bg-[#14C38E] mobile:border-[#14C38E] mobile:text-white laptop:bg-[#fff] laptop:border-[#E9ECF1] laptop:text-[#333333]" @click="addButtonClicked()">
        <span class="w-[26px] h-[26px] rounded-full flex items-center justify-center bg-[#14C38E] mobile:border-[1.5px] mobile:border-white laptop:border-0">
          <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 1.5v11M1.5 7h11" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" /></svg>
        </span>
        Add Items Manually
      </button>
    </div>

    <div class="mobile:hidden tablet:grid grid-cols-[minmax(0,200px)_minmax(0,230px)_1fr] gap-[20px] items-center h-[40px] px-[16px] rounded-[5px] bg-[#A3AAD2] text-[14px] font-medium text-white">
      <span>Title</span>
      <span>Price</span>
      <span class="text-right">Action</span>
    </div>

    <div v-if="!additionalItems || !additionalItems.length" class="py-[20px] text-center">
      <p class="m-0 text-[14px] leading-[20px] font-medium text-[#8A9099]">No miscellaneous items added</p>
      <p class="m-0 text-[12px] leading-[19px] text-[#A8AEB8]">Add trip charges, consumables or one-off line items here.</p>
    </div>

    <div v-for="(item, index) in additionalItems" :key="index"
      class="grid grid-cols-1 tablet:grid-cols-[minmax(0,200px)_minmax(0,230px)_1fr] gap-[10px] tablet:gap-[20px] items-center mt-[8px] p-[10px] tablet:px-[12px] rounded-[5px] border-1 border-[#EFEFEF] bg-white">
      <label class="m-0">
        <span class="tablet:hidden block mb-[5px] text-[13px] text-[#666666]">Title</span>
        <input v-model="item.title" type="text" placeholder="Enter Title"
          class="w-full h-[34px] px-[8px] rounded-[5px] border-1 border-[#EFEFEF] outline-none text-[14px] text-[#333333] placeholder:text-[#A8AEB8]">
      </label>
      <label class="m-0">
        <span class="tablet:hidden block mb-[5px] text-[13px] text-[#666666]">Price</span>
        <span class="flex items-center h-[34px] rounded-[5px] border-1 border-[#EFEFEF] overflow-hidden bg-white">
          <span class="w-[30px] h-full flex items-center justify-center bg-[#A3AAD2] text-white text-[14px]">$</span>
          <input v-model="item.price" type="text" inputmode="decimal" placeholder="Enter Price"
            class="flex-1 min-w-0 h-full px-[8px] border-0 outline-none bg-transparent text-[14px] text-[#333333] placeholder:text-[#A8AEB8]"
            @paste="disablePaste($event)" @keypress="isNumberLimitation($event)" @input="isNumberLimitation($event)"
            @drop.prevent @dragover.prevent>
        </span>
      </label>
      <div class="flex items-center justify-between tablet:justify-end gap-[20px]">
        <div class="flex items-center gap-[20px] text-[14px] text-[#333333]">
          <!-- 1 = Recommended (yellow), 2 = Required (red) -->
          <label v-for="opt in [{ value: '1', label: 'Recommended', color: '#F5B301' }, { value: '2', label: 'Required', color: '#EE5851' }]" :key="opt.value"
            :for="index + '-' + opt.label" class="flex items-center gap-[8px] m-0 cursor-pointer whitespace-nowrap">
            <input :id="index + '-' + opt.label" v-model="item.type" type="radio" class="sr-only" :name="'misc-' + index" :value="opt.value">
            <span class="w-[18px] h-[18px] rounded-full border-[1.5px] bg-white flex items-center justify-center" :style="{ borderColor: opt.color }">
              <span v-if="item.type == opt.value" class="w-[10px] h-[10px] rounded-full" :style="{ backgroundColor: opt.color }" />
            </span>
            {{ opt.label }}
          </label>
        </div>
        <button type="button" aria-label="Remove item" class="w-[26px] h-[26px] flex-shrink-0 rounded-full border-0 bg-[#FDECEC] flex items-center justify-center" @click="removeItem(index)">
          <svg width="12" height="13" viewBox="0 0 12 13" fill="none" aria-hidden="true"><path d="M1.5 3.2h9M4.4 3.2V2a.8.8 0 0 1 .8-.8h1.6a.8.8 0 0 1 .8.8v1.2M2.6 3.2l.5 7.9a1 1 0 0 0 1 .9h3.8a1 1 0 0 0 1-.9l.5-7.9" stroke="#EE5851" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  components: {},
  props: ["additionalItems"],
  data() {
    return {
      // items: this.additionalItems
    };
  },

  methods: {
    formatValue(event) {
      let inputValue = event.target.value;
      // Replace any non-digit characters except for a single dot
      inputValue = inputValue.replace(/[^0-9.]/g, "");
      // Limit to 2 decimal places
      const parts = inputValue.split(".");
      if (parts[1]) {
        parts[1] = parts[1].slice(0, 2);
      }
      this.value = parts.join(".");
    },
    addButtonClicked() {
      let res = true;
      let msg = "";
      this.additionalItems.forEach((element) => {
        if (element.title.length <= 0) {
          msg = "Title field is required.";
          res = false;
        } else if (element.price.length <= 0) {
          msg = "Price field is required.";
          res = false;
        }
      });

      if (res) {
        this.additionalItems.unshift({ type: 1, price: "", title: "" });
      } else {
        toast.error(msg);
      }
    },

    removeItem(index) {
      this.additionalItems.splice(index, 1);
    },

    disablePaste(event) {
      event.preventDefault();
    },

    isNumberLimitation(evt) {
      const inputElement = evt.target;
      let value = inputElement.value;

      if (evt.type === 'input') {
        // Remove non-numeric and multiple decimal points
        value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

        const [integer, decimal] = value.split('.');

        // Restrict integer part to 5 digits
        if (integer.length > 5) value = integer.slice(0, 5);

        // Restrict decimal part to 2 digits
        if (decimal) {
          if (integer === "") {
            value = "";
          } else {
            value = `${integer}.${decimal.slice(0, 2)}`;
          }
        }

        // Prevent starting with '.'
        if (value.startsWith('.') || value === '') {
          value = '';
        }

        // re-dispatch only on a change, otherwise this @input handler calls itself forever (QA D-46)
        if (inputElement.value !== value) {
          inputElement.value = value;
          inputElement.dispatchEvent(new Event('input', { bubbles: true }));
        }

      } else if (evt.type === 'keypress') {
        const charCode = evt.which || evt.keyCode;

        // Allow backspace, delete, tab, numbers (0-9), and a single '.'
        if (charCode === 8 || charCode === 46 || charCode === 9 || (charCode >= 48 && charCode <= 57)) {
          if (charCode === 46 && value.indexOf('.') !== -1) {
            evt.preventDefault();
            return false;
          }
          return true;
        }
        evt.preventDefault();
        return false;
      }
    },

    isNumber(evt) {
      const inputElement = evt.target;
      let value = inputElement.value;
      if (evt.type === 'input') {
        value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        const [integer, decimal] = value.split('.');
        if (integer.length > 4) value = integer.slice(0, 4);
        if (decimal) {
          if (integer === "") {
            value = "";
          } else {
            value = `${integer}.${decimal.slice(0, 2)}`;
          }
        }
        if (value.startsWith('.') || value === '') {
          value = '';
        }
        // re-dispatch only on a change, otherwise this @input handler calls itself forever (QA D-46)
        if (inputElement.value !== value) {
          inputElement.value = value;
          inputElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } else if (evt.type === 'keypress') {
        const charCode = evt.which || evt.keyCode;
        if (charCode === 8 || charCode === 46 || charCode === 9 || (charCode >= 48 && charCode <= 57)) {
          if (charCode === 46 && value.indexOf('.') !== -1) {
            evt.preventDefault();
            return false;
          }
          return true;
        }
        evt.preventDefault();
        return false;
      }
      // Remove invalid characters and multiple decimal points
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      const [integer, decimal] = value.split('.');
      // Restrict length
      if (integer.length > 4) value = integer.slice(0, 4);
      if (decimal) value = value.split('.')[0] + '.' + decimal.slice(0, 2);
      inputElement.value = value;
    },
  },
};
</script>

<style></style>
